import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const AddIcon: React.FC<AddIconProps> = ({ size = 22, color = '#1E1F22', className, onClick }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M5 10H15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 15V5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AddIcon;
